import React from 'react';

import { ArrowForward, Dashboard } from '@tmap/mmm-style-guide/src/Icon';
import { Alert } from '@tmap/mmm-style-guide/src/Alert';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Chip } from '@tmap/mmm-style-guide/src/Chip';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Box } from '@tmap/mmm-style-guide/src/Box';

const NewChip = styled(Chip)(({ theme }) => ({
  height: 'unset',
  fontWeight: 500,
  fontSize: '10px',
  marginLeft: theme.spacing(4),
  left: 0,
  position: 'absolute',
  [theme.breakpoints.down('md')]: {
    position: 'static',
    marginLeft: 0,
    marginBottom: theme.spacing(0.5),
  },
}));

const StyledAlert = styled(Alert)(({ theme }) => ({
  position: 'relative',
  color: theme.palette.info.main,
  '.MuiAlert-message': {
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      '& .MuiButton-root': {
        marginTop: theme.spacing(1),
      },
    },
  },
}));

function EditorBannerCta(props) {
  const { community } = props;
  const link = `/moving-living/${community.slug.current}/editor`;
  return (
    <StyledAlert severity='info' icon={false}>
      <NewChip label='New!' variant='outlined' color='info' size='small' />
      <Box display='inline-flex' alignItems='center'>
        <Dashboard sx={{ marginRight: 1 }} />
        <Typography variant='body2' whiteSpace='nowrap'>Customize your page content with the</Typography>
      </Box>
      <Button variant='contained' size='small' endIcon={<ArrowForward />} color='info' sx={{ marginLeft: 0.5, textWrap: 'nowrap' }} href={link}>
        Community Editor
      </Button>
    </StyledAlert>
  );
}

export default EditorBannerCta;
